import { partnerImagePath } from "@/utils";
import { Button, ChakraProps, Flex, Img, Text, useBreakpointValue } from "@chakra-ui/react";
import { useState } from "react";
import { FaPen } from "react-icons/fa";

type CardAddressProps = {
  titleAddress: string;
  address1: string;
  address2: string;
  customMb?: string;
  notBr?: boolean;
  client?: string;
  widthContainer?: string | string[];
  widthBoxAddress?: string | string[];
  index?: number;
  Callback?: (key: number) => void;
  editable?: boolean;
} & ChakraProps;

type PartnerCardProps = {
  image: string;
  local: string;
  priceCar?: string;
  priceUtility?: string;
  distance: string;
};

export function CardAddress({
  titleAddress,
  client,
  address1,
  editable,
  address2,
  widthContainer,
  widthBoxAddress,
  index,
  Callback,
  ...rest
}: CardAddressProps) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  const [fav, setFav] = useState(false);

  return (
    <Flex
      width={widthContainer ?? ["full", "855px"]}
      bgColor={"ll-gray.600"}
      border={"1px solid #F7F5F6"}
      borderRadius={"50px"}
      pl={"35px"}
      pr={"10px"}
      py={"5px"}
      justifyContent={"space-between"}
    >
      <Flex direction="column" justifyContent="center">
        <Text color={"ll-blue.main"} fontWeight={"500"} as="h3" fontSize={["14px", "20px"]}>
          {titleAddress}
        </Text>
        <Text as="span" fontSize={["text3", "text1"]} textStyle={"Regular"} lineHeight="1.2em">
          {address1}, {address2}
        </Text>
      </Flex>
      {isWideVersion && (
        <Button
          w="10%"
          as="button"
          height="5rem"
          border={"none"}
          justifyContent="center"
          bg={"transparent"}
          cursor="pointer"
          disabled={editable}
          _hover={{ opacity: "0.5" }}
          onClick={() => {
            Callback(index), console.log("o id?", index);
          }}
        >
          <Flex direction={"column"} alignItems="center">
            <FaPen />
            <Text mt="5px" textStyle={"Regular"} fontSize="text1">
              Alterar
            </Text>
          </Flex>
        </Button>
      )}
      {!isWideVersion && (
        <Flex
          w="30%"
          as="button"
          direction="column"
          alignItems="center"
          justifyContent="center"
          onClick={() => Callback(index)}
          cursor="pointer"
        >
          <FaPen />
          <Text mt="5px" fontWeight="medium" fontSize="text3" color={"ll-blue.main"}>
            Alterar
          </Text>
        </Flex>
      )}
    </Flex>
  );
}

export function PartnerCard({ priceUtility, priceCar, distance, local, image }: PartnerCardProps) {
  function validateColor(text) {
    if (
      text === "Montagem por pneu (carro): Grátis!" ||
      text === "Montagem por pneu (utilitário): Grátis!"
    ) {
      return "black";
    } else {
      return "";
    }
  }

  return (
    <Flex alignItems="center" minW={["250px", "400px"]}>
      <Img src={partnerImagePath(image)} width={["80px", "125px"]} mr={["10px", "20px"]} />
      <Flex direction="column" w="250px">
        <Text textStyle="Bold" fontSize={["text1", "text1"]}>
          {local}
        </Text>
        <Text textStyle="Bold" fontSize={["text4", "text3"]}>
          {distance}
        </Text>
        <Text fontSize={["text4", "text3"]} color={validateColor(priceCar)}>
          {priceCar.replace("!", "")}
        </Text>
        <Text fontSize={["text4", "text3"]} color={validateColor(priceUtility)}>
          {priceUtility.replace("!", "")}
        </Text>
      </Flex>
    </Flex>
  );
}

export function SimpleCardAddress({ titleAddress, address1, address2 }) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Flex height="60px" mb="30px">
      <Flex
        width="400px"
        backgroundColor="gray.50"
        direction="column"
        justifyContent="center"
        p={isWideVersion ? "0px 30px" : "10px 15px"}
      >
        <Text as="h4" fontWeight="medium" fontSize={isWideVersion ? "" : "14px"}>
          {titleAddress}
        </Text>
        <Text as="span" fontSize="12px" lineHeight="1.2em">
          {address1}, {address2}
        </Text>
      </Flex>
      <Flex
        width="65px"
        direction="column"
        alignItems="center"
        justifyContent="center"
        border="1px"
        borderStyle="solid"
        borderColor="gray.50"
        cursor="pointer"
      >
        <FaPen />
        <Text mt="5px" textStyle="Regular" fontSize={isWideVersion ? "16px" : "12px"}>
          Alterar
        </Text>
      </Flex>
    </Flex>
  );
}
